import { StyleSheet } from 'react-native'

export const IconContainerStyles = StyleSheet.create( {
	iconContainer: {
		width: '100%',
		height: '100%',
		justifyContent: 'center',
		alignItems: 'center',
	}
});
